import React, { useState, useEffect } from 'react';
import { categoryService } from '../services/categoryService';

/**
 * Simple <select> with root ML categories for filter bars.
 * Falls back to an empty list if API is unavailable.
 */
export default function CategoryFilterSelect({ value, onChange, className, style }) {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    categoryService.getRoots()
      .then(setCategories)
      .catch(() => setCategories([]));
  }, []);

  return (
    <select className={className} style={style} value={value} onChange={onChange}>
      <option value="">Todas las categorías</option>
      {categories.map((c) => (
        <option key={c.id} value={c.name}>{c.name}</option>
      ))}
    </select>
  );
}
